import { render, staticRenderFns } from "./tabPoItemsUpgrade.vue?vue&type=template&id=fff8170c&"
import script from "./tabPoItemsUpgrade.vue?vue&type=script&lang=js&"
export * from "./tabPoItemsUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fff8170c')) {
      api.createRecord('fff8170c', component.options)
    } else {
      api.reload('fff8170c', component.options)
    }
    module.hot.accept("./tabPoItemsUpgrade.vue?vue&type=template&id=fff8170c&", function () {
      api.rerender('fff8170c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabPoItemsUpgrade.vue"
export default component.exports